export default theme => ({
  container: {
    // display: 'inline-block',
    textAlign: 'left',
    backgroundColor: theme.palette.white.main,
    width: 600,
    height: 300,
    '& h5': {
      color: theme.palette.green.main,
    },
    [theme.breakpoints.down('md')]: {
      margin: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      width: 400,
      height: 600,
    },
    [theme.breakpoints.down('xs')]: {
      width: 300,
    },
  },
  grid: {
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      '& > div': {
        minHeight: '50%',
        width: 'inherit',
      },
    },
  },
  image: {
    width: '100%',
    height: 300,
    objectFit: 'cover',
  },
  textContent: {
    height: '100%',
    padding: theme.spacing(3),
    '& button': {
      marginLeft: -theme.spacing(0.75),
    },
    '& p': {
      marginBottom: theme.spacing(1),
    },
  },
});
